import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"

interface PkBadgeProps {
  className?: string
}

/** Small "PK" badge with a tooltip, marking a column as an entity's primary key. */
export function PkBadge({ className }: PkBadgeProps) {
  const { translate } = useTranslation()

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "font-mono inline-flex h-4 shrink-0 cursor-default items-center rounded border border-primary/40 bg-primary/10 px-1 text-[9px] font-semibold uppercase tracking-wide text-primary",
              className,
            )}
          >
            {translate("MC_MD_MAP_PK_BADGE")}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[220px]">
          {translate("MC_MD_MAP_PK_TOOLTIP")}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
